import { doc, serverTimestamp, setDoc } from 'firebase/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { useData } from '../contextProviders/DataProvider';
import { firestore } from '../firebase';
import { USGA_COURSE_REFRESH_PATH, USGA_COURSE_REFRESH_STATUSES } from '../types/UsgaCourseRefresh';

export const useUsgaCourseRefreshMutators = () => {
  const { isGod } = useAuth();
  const { userState } = useData();

  /** Asks the server to re-read every USGA-linked course's posting season (handleUsgaCourseRefreshRequested). */
  const requestUsgaCourseRefresh = async (): Promise<void> => {
    if (!isGod) {
      console.error('Permission denied: only god users can refresh USGA course data');
      return;
    }
    const requestedBy = userState.status === 'ready' ? userState.userProfile?.itemId ?? null : null;
    await setDoc(doc(firestore, USGA_COURSE_REFRESH_PATH), {
      status: USGA_COURSE_REFRESH_STATUSES.REQUESTED,
      requestedBy,
      requestedAt: serverTimestamp(),
    }, { merge: true });
  };

  return { requestUsgaCourseRefresh };
};
